import { resolveUploadUrl, resolveImageAssetUrl, IMAGE_PUBLIC_BASE } from '@/utils/uploadBase'

const IMAGE_BASE = `${IMAGE_PUBLIC_BASE}/`

export function resolveImageUrl(imageName) {
	if (!imageName) return ''
	const raw = String(imageName).trim()
	if (!raw) return ''
	if (/^https?:\/\//i.test(raw)) {
		if (/wvxvb\.cn\/upload/i.test(raw) || /\/app\/oss\/file\/upload/i.test(raw)) {
			return resolveUploadUrl(raw)
		}
		if (/wvxvb\.cn\/images/i.test(raw)) {
			return resolveImageAssetUrl(raw)
		}
		return raw
	}
	const clean = raw.replace(/^\/static\/images\//, '').replace(/^\/+/, '')
	if (/^upload\//i.test(clean) || /^\d{14,}\w*\.(png|jpe?g|gif|webp|bmp)$/i.test(clean)) {
		return resolveUploadUrl(clean)
	}
	return IMAGE_BASE + clean
}
